"use client";

import { FaChevronLeft } from "react-icons/fa";
import { FiMenu } from "react-icons/fi";

interface ChatDetailScreenProps {
  onBack: () => void;
}

export default function ChatDetailScreen({ onBack }: ChatDetailScreenProps) {
  return (
    <div className="h-full bg-background text-foreground flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-border">
        <div className="flex items-center">
          <button onClick={onBack} className="mr-3">
            <FaChevronLeft className="text-blue-400 text-xl" />
          </button>
          <span className="text-blue-400 text-lg mr-3">Chat</span>
          <h1 className="text-lg">FXPRO Financial Services Ltd</h1>
        </div>
        <div className="w-12 h-12 rounded-full bg-blue-500 flex items-center justify-center">
          <FiMenu className="text-foreground text-2xl" />
        </div>
      </div>

      {/* Chat Messages */}
      <div className="flex-1 overflow-y-auto px-4 py-4">
        {/* Date Divider */}
        <div className="text-center text-muted-foreground text-sm mb-6">
          December 27, 2024
        </div>

        {/* Message */}
        <div className="flex items-start mb-4">
          <div className="w-12 h-12 rounded-full bg-blue-500 flex items-center justify-center mr-3 flex-shrink-0">
            <FiMenu className="text-foreground text-xl" />
          </div>
          <div className="flex-1">
            <div className="flex items-baseline gap-3 mb-2">
              <span className="font-medium">FXPRO Financial Services Ltd</span>
              <span className="text-muted-foreground text-sm">17:03</span>
            </div>
            <div className="space-y-4">
              <p className="text-base">Margin Call Alert!</p>
              <p className="text-base">
                Your Margin Level has fallen below 60.00%
              </p>
              <p className="text-base">
                Please note that at 50.00% or less, positions will be
                automatically closed.
              </p>
              <p className="text-base">
                Top up now to prevent getting stopped out!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
